import './DispatcherPanelComponent.css';
import NewRequestPanel from './NewRequestPanel';
import MapTimelineComponent from './MapTimelineComponent';
import OpsViewComponent from './OpsViewComponent';

const DispatcherPanelComponent = () => {
    return <div id="dispatcher" className="grid-parent dispatcher-layout">
        <div className="dispatch-override grid-parent">
            <div className="dispatcher-pager">Dispatcher</div>
        </div>
        <NewRequestPanel />
        <div class="blurb drag-blurb-edit">
            <div class="title">Drag-and-Drop Action Pins</div>
            Dispatchers can place, move, or remove <br/>
            roadway pins directly on the map to manage <br/>
            traffic flow, guide civilian traffic, and support <br/>
            emergency response operations in real time.
        </div>
        <MapTimelineComponent />
        <div class="blurb drag-blurb-edit">
            <div class="title">End-to-End Route</div>
            Movement logic for all emergency routes:<br/>
            from dispatch, through traffic, to destination.
        </div>
        <OpsViewComponent />
    </div>
}

export default DispatcherPanelComponent;